if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (this.cart && document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // NEXO: el panel lateral se resuelve EN EL MOMENTO DEL ENVIO, nunca en el constructor.
      // cart-drawer.js es un script diferido que se registra al final del documento, es decir
      // DESPUES de que este componente se construya: preguntarle antes de tiempo siempre daba
      // "no disponible" y mandaba al cliente a /cart aunque el panel funcionase perfectamente.
      // Aqui, con la pagina ya cargada, la respuesta es fiable: si el componente esta registrado
      // se usa el panel; si de verdad no lo esta, el destino es el carrito.
      resolveCart() {
        const el = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        return el && typeof el.getSectionsToRender === 'function' ? el : null;
      }

      // NEXO: ultimo recurso. Envio nativo del formulario a /cart/add, que Shopify procesa en
      // servidor y responde redirigiendo a /cart. No depende de fetch, de JSON, ni de que ningun
      // asset del tema haya cargado: mientras el navegador sepa enviar un formulario, se vende.
      fallbackToNativeSubmit(reason) {
        // Once an AJAX request starts, its outcome may be uncertain: never POST twice.
        if (this.cartRequestStarted) {
          this.recoverCartRequest(reason);
          return;
        }
        if (this.nativeSubmitDone) return;
        this.nativeSubmitDone = true;
        console.warn('[NEXO] add-to-cart degradado a envio nativo:', reason);
        try {
          window.clearTimeout(this.stuckTimer);
          // Sin return_to, un envio nativo deja al cliente en la respuesta cruda
          // de /cart/add. Con el, Shopify lo lleva a su carrito ya montado.
          if (!this.form.querySelector('input[name="return_to"]')) {
            const volver = document.createElement('input');
            volver.type = 'hidden';
            volver.name = 'return_to';
            volver.value = (window.routes && window.routes.cart_url) || '/cart';
            this.form.appendChild(volver);
          }
          HTMLFormElement.prototype.submit.call(this.form);
        } catch (submitErr) {
          window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        }
      }

      // A timeout or lost response does not mean Shopify rejected the addition.
      // Open the cart with a GET so the customer can check the result, without
      // submitting the same item again. Ignore a late response after navigation.
      recoverCartRequest(reason) {
        if (this.cartRecoveryStarted) return;
        this.cartRecoveryStarted = true;
        window.clearTimeout(this.stuckTimer);
        console.warn('[NEXO] comprobando carrito tras respuesta incierta:', reason);
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }

      // NEXO: CartPerformance y publish viven en global.js. Si ese asset no llego, medir o publicar
      // no puede tumbar una compra.
      safely(fn) {
        try {
          return fn();
        } catch (err) {
          console.warn('[NEXO] paso no critico omitido en add-to-cart:', err);
          return undefined;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.cartRecoveryStarted || this.nativeSubmitDone) return;
        this.cartRequestStarted = false;

        this.handleErrorMessage();

        // Con la pagina ya cargada, esta es la lectura buena del estado del panel lateral.
        this.cart = this.resolveCart();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // If the request stalls, inspect the cart; do not automatically repeat the POST.
        window.clearTimeout(this.stuckTimer);
        this.stuckTimer = window.setTimeout(() => this.recoverCartRequest('sin respuesta en 8s'), 8000);

        try {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];

          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.safely(() => this.cart.setActiveElement(document.activeElement));
          }
          config.body = formData;

          if (typeof fetch !== 'function') throw new Error('fetch unavailable');
          const cartAddUrl = routes.cart_add_url;
          this.cartRequestStarted = true;
          fetch(cartAddUrl, config)
            .then((response) => response.json())
            .then((response) => {
              if (this.cartRecoveryStarted) return;
              if (response.status) {
                this.safely(() =>
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  })
                );
                this.handleErrorMessage(response.description);

                const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                this.submitButton.setAttribute('aria-disabled', true);
                this.submitButtonText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
                this.error = true;
                return;
              }

              // NEXO: el aviso de "carrito actualizado" va PRIMERO y solo. De el cuelgan el
              // modal de recomendaciones, el de agotado y la medicion de negocio. Antes viajaba
              // atado a la medicion de rendimiento (si CartPerformance fallaba se perdian los
              // dos) y por detras de la redireccion a /cart (si el panel no estaba disponible,
              // el cliente se iba sin que el modal llegara a existir). Emitirlo aqui garantiza
              // que se anuncie siempre que el producto haya entrado de verdad en el carrito.
              this.error = false;
              this.safely(() =>
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                })
              );

              // La medicion de rendimiento es accesoria: si falla, no arrastra a nadie.
              this.safely(() => {
                const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });

              // Sin panel lateral disponible, el destino es el carrito. Se va DESPUES de anunciar.
              if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              // NEXO: recheck de precio proveedor (prv_HB) en segundo plano. Fire-and-forget:
              // no bloquea ni hace esperar al usuario. El servidor solo encola; un worker hace el resto.
              if (this.hasAttribute('data-hb-recheck') && navigator.sendBeacon) {
                try {
                  const hbVariantId = formData.get('id');
                  if (hbVariantId) {
                    const hbBlob = new Blob([JSON.stringify({ variant_id: hbVariantId })], { type: 'text/plain' });
                    navigator.sendBeacon('https://www.recambiosyaccesoriosbmw.com/api/storefront/cart-price-recheck', hbBlob);
                  }
                } catch (hbErr) {
                  /* nunca debe afectar al add-to-cart */
                }
              }

              if (window.VicshopBrowseTracking && typeof window.VicshopBrowseTracking.trackAddToCart === 'function') {
                try {
                  window.VicshopBrowseTracking.trackAddToCart({
                    variant_id: formData.get('id'),
                    quantity: formData.get('quantity') || 1,
                    product: window.VicshopBrowseProduct || null,
                    cart_add_response: response,
                  });
                } catch (browseTrackErr) {
                  /* nunca debe afectar al add-to-cart */
                }
              }

              // NEXO: a partir de aqui el producto YA esta en el carrito. Si pintar el panel falla,
              // la venta no se pierde: se lleva al cliente al carrito.
              let painted = false;
              const paint = () => {
                if (painted) return;
                painted = true;
                try {
                  this.cart.renderContents(response);
                } catch (renderErr) {
                  console.warn('[NEXO] no se pudo pintar el carrito lateral, voy a /cart:', renderErr);
                  window.location = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
                }
              };

              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      try {
                        CartPerformance.measure('add:paint-updated-sections', paint);
                      } catch (perfErr) {
                        paint();
                      }
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                try {
                  CartPerformance.measure('add:paint-updated-sections', paint);
                } catch (perfErr) {
                  paint();
                }
              }
            })
            .catch((e) => {
              console.error(e);
              this.recoverCartRequest('respuesta no confirmada de /cart/add');
            })
            .finally(() => {
              window.clearTimeout(this.stuckTimer);
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error && !this.cartRecoveryStarted) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');

              this.safely(() => CartPerformance.measureFromEvent('add:user-action', evt));
            });
        } catch (fatalErr) {
          // NEXO: cualquier excepcion sincrona (asset ausente, API del navegador que falta) caia
          // antes fuera de la promesa, dejando el boton girando para siempre sin enviar nada.
          console.error('[NEXO] add-to-cart no pudo usar la via rapida:', fatalErr);
          this.fallbackToNativeSubmit('excepcion antes del envio');
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
